/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-sticky-header-separator-inner',
    template: ``,
    styles: [':host {height: 24px; display: inline-block; border-left: solid 1px #999999; margin: 0 16px; opacity: 0.3;}'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StickyHeaderInnerSeparatorComponent {
}
